/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import template from "./ns-featured-panel.html";
import "../ns-featured-panel-link/ns-featured-panel-link.js";

/**
 * <p>This Component probably needs an overhaul</p>
 *
 * <h2>UX/Design Docs</h2>
 * <p>Need to find</p>
 *
 * <h2>Demo</h2>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-featured-panel
 *     card-alignment="left"
 *     background-type="Full Background Image"
 *     title="A Great Title!"></ns-featured-panel>
 *   </template>
 * </demo-snippet>
 *
 * <marked-element>
 *  <div slot="markdown-html">
 *  <script type="text/markdown">
 *
 *      ### Styling
 *
 *      ##### `<ns-expressive-link>` provides the following custom properties and mixins for styling:
 *
 *      Custom property                 | Description                                           | Default
 *      --------------------------------|-------------------------------------------------------|-------------------
 *      `--ns-featured-panel `          | Not implemented                                       | `{}`
 *
 *      ### Slots
 *
 *      ##### `<ns-expressive-link>` provides the following slots for content:
 *
 *      Custom property                 | Description                           | Default
 *      --------------------------------|---------------------------------------|-------------------
 *      `default`                       | Not Implemented                       | `'Sample Link'`
 *
 *  </script>
 * </marked-element>
 */
export class NsFeaturedPanel extends PolymerElement {
  constructor() {
    super();
  }

  static get is() {
    return "ns-featured-panel";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  ready() {
    super.ready();
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("dom-change", () => {
      if (this.contentType.type === "video content") {
        let videoButton = this.shadowRoot.querySelector("#videoButton");
        if (videoButton) {
          videoButton.addEventListener("click", () => {
            this._togglePlay();
          });
          let videoEl = this.shadowRoot.querySelector("#video-0");
          videoEl.onended = () => {
            this.videoPlaying = false;
            videoEl.controls = false;
          };
        }
      }
      if (navigator.userAgent.indexOf("Trident") > -1) {
        let backgroundBanner = this.shadowRoot.querySelector(
          ".background-banner"
        );
        if (backgroundBanner) {
          backgroundBanner.style["background-image"] =
            "url(" + this.headerImage.fileReference + ")";
        }
      }
    });
  }

  static get properties() {
    return {
      backgroundType: String,
      colorBlock: String,
      cardAlignment: String,
      contentType: {
        type: Object,
        value: {},
        computed:
          "_computeContentType(backgroundType, colorBlock, cardAlignment)"
      },
      video: {
        type: Object,
        value: {}
      },
      headerImage: {
        type: Object,
        value: {
          fileReference: "https://via.placeholder.com/1200x1200"
        }
      },
      title: String,
      text: {
        type: String
      },
      videoPlaying: {
        type: Boolean,
        value: false
      }
    };
  }

  _computeContentType(backgroundType, colorBlock, cardAlignment) {
    let contentType = {
      type: "",
      class: ""
    };
    console.log("head", this.headerImage);
    if (backgroundType === "Media") {
      contentType.type = "video content";
      contentType.class = "video-content";
    } else if (backgroundType === "Card Only") {
      contentType.type = "no banner";
      contentType.class = "nobanner-content";
    } else if (
      backgroundType === "Full Background Image" &&
      cardAlignment === "Left"
    ) {
      contentType.type = "left";
      contentType.class = "left-content";
    } else if (
      backgroundType === "Full Background Image" &&
      cardAlignment === "Right"
    ) {
      contentType.type = "right";
      contentType.class = "right-content";
    } else if (
      backgroundType === "half image half block" &&
      cardAlignment === "Right" &&
      colorBlock === "Blue"
    ) {
      contentType.type = "semi content";
      contentType.class = "semi-content";
    } else if (
      backgroundType === "half image half block" &&
      cardAlignment === "Right" &&
      colorBlock === "White"
    ) {
      contentType.type = "semi content white";
      contentType.class = "semi-content-white";
    } else if (
      backgroundType === "half image half block" &&
      cardAlignment === "Left" &&
      colorBlock === "Blue"
    ) {
      contentType.type = "semi content left dark";
      contentType.class = "semi-content-left-dark";
    } else if (
      backgroundType === "half image half block" &&
      cardAlignment === "Left" &&
      colorBlock === "White"
    ) {
      contentType.type = "semi content left light";
      contentType.class = "semi-content-left-light";
    }

    return contentType;
  }

  _isEqualTo(first, second) {
    return first === second;
  }

  _shouldApplyClass(
    contentType,
    desiredContentType,
    shouldEqual,
    classToApply
  ) {
    if ((contentType === desiredContentType).toString() === shouldEqual) {
      return classToApply;
    } else {
      return "";
    }
  }

  _togglePlay() {
    let videoEl = this.shadowRoot.querySelector("#video-0");
    videoEl.controls = true;
    videoEl.play();
    this.videoPlaying = true;
  }
}

customElements.define(NsFeaturedPanel.is, NsFeaturedPanel);
